var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrouphome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 725,
    height: 681,
    viewBox: "0 0 725 681",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M472.853 83.6007L473 83.4541V83.2462V0.5H562.814V120.483L361.915 320.578L161.352 120.483V0.5H251.165V83.2462V83.4537L251.312 83.6002L361.562 193.592L361.915 193.944L362.268 193.593L472.853 83.6007Z",
    stroke: "url(#paint0_linear_5957_13500)",
    strokeOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.313 597.399L251.165 597.546V597.754V680.5H161.352V560.518L362.25 360.756L562.814 560.518V680.5H473V597.754V597.546L472.853 597.4L362.603 487.408L362.251 487.056L361.898 487.407L251.313 597.399Z",
    stroke: "url(#paint1_linear_5957_13500)",
    strokeOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M640.369 452.358L640.515 452.505H640.722H723.664V541.772H603.397L402.835 341.678L603.397 141.585H723.664V230.852H640.722H640.515L640.369 230.999L530.119 341.325L529.766 341.678L530.119 342.032L640.369 452.358Z",
    stroke: "url(#paint2_linear_5957_13500)",
    strokeOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7956 230.999L83.649 230.852H83.4414H0.5V141.585H120.766L321.329 342.012L120.767 541.772H0.5V452.505H83.4414H83.6481L83.7945 452.359L194.044 342.367L194.398 342.014L194.045 341.66L83.7956 230.999Z",
    stroke: "url(#paint3_linear_5957_13500)",
    strokeOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5957_13500",
    x1: 362.083,
    y1: 0,
    x2: 362.083,
    y2: 321.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5957_13500",
    x1: 362.083,
    y1: 360.051,
    x2: 362.083,
    y2: 681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5957_13500",
    x1: 563.145,
    y1: 141.085,
    x2: 563.145,
    y2: 542.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5957_13500",
    x1: 161.018,
    y1: 141.085,
    x2: 161.018,
    y2: 542.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrouphome);
export default __webpack_public_path__ + "static/media/Group home.3fdbf6a52b5718a3e1461a2d1eb72f61.svg";
export { ForwardRef as ReactComponent };